module.exports = __webpack_public_path__ + "img/box05_08.88e80d74.jpg";